import { render } from "./Accordian.vue?vue&type=template&id=0fbeab2e&scoped=true"
import script from "./Accordian.vue?vue&type=script&lang=js"
export * from "./Accordian.vue?vue&type=script&lang=js"

import "./Accordian.vue?vue&type=style&index=0&id=0fbeab2e&lang=scss&scoped=true"

import exportComponent from "/Users/umar/Desktop/umi-portfolio-2021/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fbeab2e"]])

export default __exports__